function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceWrapup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "17.25 7.25 17.25 6 6 6 6 19.75 6 26 8.46 26 8.46 19.75 17.25 19.75 17.25 21 26 21 26 7.25 17.25 7.25",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.25,
    y: 7.25,
    width: 3.75,
    height: 3.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 11,
    width: 3.75,
    height: 3.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.25,
    y: 14.75,
    width: 3.75,
    height: 3.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.25,
    y: 12.25,
    width: 3.75,
    height: 3.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 8.5,
    width: 3.75,
    height: 3.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 16.01,
    width: 3.75,
    height: 3.75,
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceWrapup);
export default __webpack_public_path__ + "static/media/presence-wrapup.9aebfc49.svg";
export { ForwardRef as ReactComponent };